import React from "react";
import { Divider, Grid } from "@mui/material";
import { dateSavedToDisplay, uomToDisplay } from "../../constants/vtrTrip";
import { getPortDisplay } from "../../constants/Sales";
import { useSelector } from "react-redux";

const SignForm2 = (props) => {
  const { port: portList = [], uomCodes = [] } = useSelector(
    (state) => state.validation.validations
  );
  if (props.currentStep !== 2) {
    return null;
  }

  return (
    <div className="SignForm2 margAll10" data-testid="SignForm2">
      {props.currentTrip.sales.map(function (d, idx) {
        let display_date_sold = dateSavedToDisplay(d.date_sold);
        let display_port = getPortDisplay(d.offloading_port, portList);
        return (
          <div key={"trip_" + idx}>
            <h2 className="center margBot20">
              {"Offload / Sale Details: " + (idx + 1)}
            </h2>
            <Divider />
            {<br />}
            <div className="textSize1p25em">
              <Grid container spacing={3}>
                <Grid item xs={4}>
                  Sales:
                </Grid>
                <Grid item xs={8}>
                  {idx + 1}
                </Grid>
              </Grid>
              <Grid container spacing={3}>
                <Grid item xs={4}>
                  Species:
                </Grid>
                <Grid item xs={8}>
                  {d.species}
                </Grid>
              </Grid>
              <Grid container spacing={3}>
                <Grid item xs={4}>
                  Sold:
                </Grid>
                <Grid item xs={8}>
                  {d.sold + " " + uomToDisplay(d.uom, uomCodes)}
                </Grid>
              </Grid>
              <Grid container spacing={3}>
                <Grid item xs={4}>
                  Dealer:
                </Grid>
                <Grid item xs={8}>
                  {d.dealer_permit_number + " - " + d.dealer_name}
                </Grid>
              </Grid>
              <Grid container spacing={3}>
                <Grid item xs={4}>
                  Port:
                </Grid>
                <Grid item xs={8}>
                  {display_port}
                </Grid>
              </Grid>
              <Grid container spacing={3}>
                <Grid item xs={4}>
                  Date Sold:
                </Grid>
                <Grid item xs={8}>
                  {display_date_sold ? display_date_sold : ""}
                </Grid>
              </Grid>
            </div>
            <Divider />
            {<br />}
          </div>
        );
      })}
    </div>
  );
};

export default SignForm2;
